var render = function render(){var _vm=this,_c=_vm._self._c;return _c('complete-table',{ref:"table",style:({ height: _vm.wrapHeight.height, width: _vm.wrapHeight.width })})
}
var staticRenderFns = []

export { render, staticRenderFns }